export abstract class BaseService {
  protected static readonly endpoint: string;
}
